import _ from "lodash";
import client from "lib/apolloClient/client";

import {
  getCourseFolders,
  getCourseFoldersDetailsQuery,
  getTaggedPostStudentFolders,
} from "./JournalQuery";
import { getCourseAllStudentQuery } from "Post/modules/PostQuery";

export const getCourseFoldersFromCache = courseId => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseFolders,
      variables: {
        courseId,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseAllStudentFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseAllStudentQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getCourseFoldersDetailsFromCache = courseId => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseFoldersDetailsQuery,
      variables: {
        courseId,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getTaggedPostStudentFoldersFromCache = ({
  courseId,
  studentIds = [],
  filters,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getTaggedPostStudentFolders,
      variables: {
        courseId,
        studentIds,
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
